<template>
  <modal-v2
    ref="modal"
    class="modal-mixed-postage-types"
    size="large"
    auto-body-height
  >
    <template #header>
      <h2>Atenção com o local de postagem</h2>
    </template>

    <template #body>
      <p>Dependendo da modalidade, alguns envios devem ser postados na unidade da transportadora.</p>

      <mui-list
        class="mt-8"
        :gap="2"
        align="stretch"
        justify="center"
      >
        <div
          v-for="(postageType, key) of postageTypes"
          :key="key"
          class="modal-mixed-postage-types__card"
        >
          <figure>
            <img
              class="modal-mixed-postage-types__illustration"
              :src="`/images/ilustrations/${postageType.illustration}.svg`"
              :alt="postageType.title"
            >
          </figure>

          <h3 class="text-highlight text-neutral-dark mb-2">{{ postageType.title }}</h3>

          <mui-list
            :gap="1"
            orientation="column"
            align="center"
            justify="center"
          >
            <span
              v-for="service in postageType.services"
              :key="service"
            >
              {{ service }}
            </span>
          </mui-list>
        </div>
      </mui-list>
    </template>

    <template #footer>
      <mui-switch
        v-if="hasCustomAction"
        v-model="savePreference"
        label="Não exibir novamente"
      />

      <button
        type="button"
        class="mui-button mui-button--primary"
        :class="{'ml-auto': hasCustomAction}"
        @click="confirm"
      >
        Continuar
      </button>
    </template>
  </modal-v2>
</template>

<script>
// DEPENDENCIES
import partition from 'lodash/partition';

// COMPONENTS
import MuiSwitch from 'commons/js/components/atoms/MUISwitch.vue';
import ModalV2 from 'commons/js/components/atoms/ModalV2';
import MuiList from "commons/js/components/organisms/MUIList";

// MIXINS
import ShippingDefinitions from 'commons/js/ShippingDefinitions';

export default {
  mixins: [ShippingDefinitions],

  components: {
    ModalV2,
    MuiList,
    MuiSwitch
  },

  props: {
    orders: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      hasCustomAction: false,
      savePreference: false
    }
  },

  computed: {
    /**
     * It returns the postage types allowed to the given orders.
     *
     * @returns {object} - An object containing the postage types allowed.
     */
    postageTypes() {
      const [industrialOrders, retailOrders] = partition(this.orders, (ord) => this.isIndustrialService(ord.service_id));

      return {
        industrial: {
          illustration: 'best-spot',
          title: 'Poste no Melhor Ponto',
          services: this.formatServices(industrialOrders)
        },

        retail: {
          illustration: 'me-labeled-box',
          title: 'Nas unidades das transportadoras',
          services: this.formatServices(retailOrders)
        }
      };
    }
  },

  methods: {
    open(options = {}) {
      if (options.customAction) {
        this.hasCustomAction = Boolean(options.customAction);
      }

      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },

    async confirm() {
      if (!this.hasCustomAction) {
        this.close();

        return
      }

      if (this.savePreference) {
        await this.updatePreferences();

        this.$emit('update-preferences');
      }

      this.close();
      await this.$nextTick();
      this.$emit('handle-confirm');
    },

    formatServices(orders) {
      const formattedServices = [
        ...new Set(orders.map(({service}) => `${service.company.name} ${service.name}`))
      ];

      return formattedServices;
    },

    updatePreferences() {
      return axios.put('/api/v2/me/preferences', {
        'mixed_postage_types_alert': (new Date()).toISOString(),
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
.modal-mixed-postage-types

  &__card
    display flex
    flex-direction column
    align-items center
    width 320px
    padding 25px 39px 40px
    background-color #F2F6F9
    border-radius 4px
    box-sizing border-box

  &__illustration
    display block
    width auto
    height 117px
    margin-bottom 16px
</style>
